import verticalSpacing from './vertical-spacing';
import horizontalSpacing from './horizontal-spacing';
import border from './border';
import shadow from './shadow';
import horizontalGap from './horizontal-gap';
import verticalGap from './vertical-gap';
import columnWidth from './column-width';

export default [
  ...verticalSpacing,
  ...horizontalSpacing,
  ...border,
  ...shadow,
  ...horizontalGap,
  ...verticalGap,
  ...columnWidth,
];
